import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=1179a4c0&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=1179a4c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1179a4c0",
  null
  
)

export default component.exports